import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { FacturasFilterModel } from 'src/app/shared/models/FacturasFilterModel';

@Injectable()
export class MenuService {
  public tilteMenu: string;
  public btnPrevius: boolean = true;
  public productoSelecionado: string;
  public codigoproductoSelecionado: string;
  public paginaPrevius: string;
  public filterFields: any;
  public facturafiltereds: FacturasFilterModel;
  public globalObraCodFilter: string;
  public globalObraNameFilter: string;
  public showModalFirstTime: boolean = true;
  public return: Subject<any>;
  /** El layout dispara este subject; el formulario de combustible escucha y ejecuta goBack(). */
  public combustibleFormularioBackClick = new Subject<void>();

  constructor() {
    this.return = new Subject();
  }
}
